import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M4,6H28a2,2,0,0,0,0-4H4A2,2,0,0,0,4,6Z"/><path d="M28,10H11a2,2,0,0,0,0,4H28a2,2,0,0,0,0-4Z"/><path d="M28,18H4a2,2,0,0,0,0,4H28a2,2,0,0,0,0-4Z"/><path d="M28,26H17a2,2,0,0,0,0,4H28a2,2,0,0,0,0-4Z"/>';
export var TextRightAlignedSVG = function TextRightAlignedSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TextRightAlignedSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TextRightAlignedSVG);